import React, { FC } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { globalTheme } from '@cld/component-theme';
import Typography from '@cld/typography';
import { TransformationInterface } from '../../../../types';
import { useAnalytics } from '../../../../hooks/useAnalytics';

const Root = styled.div`
  height: calc(${globalTheme.spacing.md} * 5 - ${globalTheme.spacing.xxs} / 2);
  width: calc(${globalTheme.spacing.xl} * 3 + ${globalTheme.spacing.xxs} / 2);
  margin: 0 calc(${globalTheme.spacing.sm} - ${globalTheme.spacing.xxs} / 2) calc(${globalTheme.spacing.sm} - ${globalTheme.spacing.xxs} / 2) 0;
  cursor: pointer;
  border: 1px solid transparent;
  overflow: hidden;
  text-align: center;
  & img {
    width: 100%;
  }
  & div {
    height: calc(${globalTheme.spacing.md} * 3 + ${globalTheme.spacing.xxs});
    overflow: hidden;
    margin-bottom: ${globalTheme.spacing.xs};
  }
  &.selected {
    border-radius: ${globalTheme.radius.lg};
    border: 1px solid ${globalTheme.palette.primary};
    div {
      height: calc(${globalTheme.spacing.sm} * 5);
      margin-bottom: 0px;
    }
  }
`;

export interface TransformationItemProps {
  onClick: ({ key, value }: { key: string; value: boolean }) => void;
  item: TransformationInterface;
}

const TransformationLabel = styled(Typography)`
  display: block;
`;

export const TransformationItem: FC<TransformationItemProps> = ({ onClick, item }) => {
  const analytics = useAnalytics();

  const handleOnClick = () => {
    analytics('edit default transformations', `${!item.isSelected ? 'select' : 'unselect'} ${item.label}`);
    onClick({ key: item.key, value: !item.isSelected });
  };
  return (
    <Root onClick={handleOnClick} className={cx({ selected: item.isSelected })} data-test={item.key} aria-checked={item.isSelected}>
      <div>
        <img src={item.image} alt={item.label} />
      </div>
      <TransformationLabel size="xs" type={item.isSelected ? 'url' : 'regular'}>
        {item.label}
      </TransformationLabel>
    </Root>
  );
};
